/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import AptMiniCard from '../../../Appointments/AptMiniCard'
import { useDispatch, useSelector } from 'react-redux'
import { togglePopup } from '../../../../../Redux/popups/popupSlice'
import { updateAppointment, deleteAppointment } from '../../../../../Redux/appointments/appointmentSlice'
import SVGMouth from '../OrganData/SVGMouth.jsx'
import { getAllUsers } from '../../../../../Redux/users/usersSlice'
import QuickEditModal from './QuickEditModal'
import { arrayOfTimesGeneral } from '../../../../pages/Appointments/timeLines'

const PatientAppointments = ({ t, appointments, currentOperation, addAptWithCurrentOp, patient, setShowGroupedTeeth }) => {
  const dispatch = useDispatch()
  const { users } = useSelector((state) => state.users)
  const { operations } = useSelector((state) => state.operations)
  const [quickEditApt, setQuickEditApt] = useState(null)
  const [quickEditForm, setQuickEditForm] = useState({
    feedback: '',
    examination: '',
    therapy: '',
    main_issue: '',
    selectedTeeth: [],
    selectedType: 'all',
    doctor_id: '',
    service_name: '',
    category: 'general',
    service_cost: 0,
    patient_pay: 0,
    difference: 0
  })
  const [showAppointmentsModal, setShowAppointmentsModal] = useState(false)
  const [selectedDateAppointments, setSelectedDateAppointments] = useState([])
  
  // Fetch users if not available
  useEffect(() => {
    if (!users?.length) {
      dispatch(getAllUsers())
    }
  }, [users, dispatch])
  
  const dateFunction = (date) => {
    // return date in object keys month (initials) and day in number
    const newDate = new Date(date)
    const day = newDate.toLocaleDateString('en-GB', { day: '2-digit' })
    const month = newDate.toLocaleDateString('en-GB', { month: '2-digit' })
    const year = newDate.toLocaleDateString('en-GB', { year: 'numeric' })
    return { day, month, year, full: `${day}/${month}/${year}` }
  }

  // Function to group appointments by date
  const groupAppointmentsByDate = (appointments) => {
    if (!appointments || !Array.isArray(appointments)) return {}
    
    return appointments.reduce((grouped, appointment) => {
      const date = appointment.date
      if (!grouped[date]) {
        grouped[date] = []
      }
      grouped[date].push(appointment)
      return grouped
    }, {})
  }

  // Function to handle clicking on a grouped appointment card
  const handleGroupedAppointmentClick = (date, appointments) => {
    setSelectedDateAppointments(appointments)
    setShowAppointmentsModal(true)
  }

  // Function to handle clicking on individual appointment in modal
  const handleAppointmentSelect = (appointment) => {
    openQuickEdit(appointment)
    setShowAppointmentsModal(false)
  }

  // Function to show all teeth from all appointments in a group
  const showAllTeethFromGroup = (appointments) => {
    // Check if any appointments have teeth selected
    const hasTeeth = appointments.some(appointment => 
      appointment.teeth_list && Array.isArray(appointment.teeth_list) && appointment.teeth_list.length > 0
    )
    
    if (!hasTeeth) {
      alert(t('no_teeth_selected_in_group') || 'No teeth selected in this group')
      return
    }
    
    // Set the grouped teeth to display in the OrganData component
    if (setShowGroupedTeeth) {
      setShowGroupedTeeth({ appointments })
    }
  }

  // Always show all appointments
  const usedAppointments = appointments

  const createAppointment = () => {
    dispatch(
      togglePopup({
        pointer: 3,
        data: { 
          creating: true, 
          patient_id: patient?.id,
          patient_name: patient?.full_name,
          operation_id: currentOperation?.id,
          operation_name: currentOperation?.op_name,
          date: new Date().toISOString().split('T')[0],
          lockPatientName: true,
          hideRoomAndTeeth: true
        }
      })
    )
  }

  // Function to directly update an appointment without using the popup
  const updateAppointmentDirectly = (appointment) => {
    // Create a properly formatted appointment object
    const updatedAppointment = {
      ...appointment,
      date: appointment.date || new Date().toISOString().split('T')[0],
      from: appointment.from || 8,
      to: appointment.to || 8.5,
      fromStr: appointment.fromStr || "08:00",
      toStr: appointment.toStr || "08:30",
      teeth_list: Array.isArray(appointment.teeth_list) ? appointment.teeth_list : [],
      room: appointment.room || '',
      feedback: appointment.feedback || '',
      examination: appointment.examination || '',
      therapy: appointment.therapy || '',
      main_issue: appointment.main_issue || '',
      category: appointment.category || 'stomatology',
      patient_id: patient?.id,
      patient_name: patient?.full_name,
      // These fields must exist for the update to work
      operation_id: appointment.operation_id || '',
      operation_name: appointment.operation_name || '',
      doctor_id: appointment.doctor_id || '',
      doctor_name: appointment.doctor_name || '',
      // Add other required fields
      unit_multiplier: appointment.unit_multiplier || 1,
      array_of_payments: appointment.array_of_payments || [],
      price: appointment.price || 0,
      is_paid: appointment.is_paid || false,
      is_ongoing: appointment.is_ongoing || false,
      color: appointment.color || '#000000'
    }
    
    // Dispatch the update action
    dispatch(updateAppointment(updatedAppointment))
  }

  const handleEditAppointment = (appointment) => {
    // Enhanced appointment data
    const enhancedAppointment = {
      ...appointment,
      editing: true,
      lockPatientName: true,
      showMouth: true,
      // Make sure date is in the correct format
      date: appointment.date || new Date().toISOString().split('T')[0],
      // Ensure these fields exist and are the right format
      teeth_list: Array.isArray(appointment.teeth_list) ? appointment.teeth_list : [],
      room: appointment.room || '',
      feedback: appointment.feedback || '',
      examination: appointment.examination || '',
      therapy: appointment.therapy || '',
      description: appointment.description || '',
      unit_multiplier: appointment.unit_multiplier || 1,
      // Make sure category is set
      category: appointment.category || 'stomatology',
      // Set time properties
      from: appointment.from || 8,
      to: appointment.to || 8.5,
      fromStr: appointment.fromStr || "08:00",
      toStr: appointment.toStr || "08:30",
      array_of_payments: appointment.array_of_payments || []
    }
    
    dispatch(
      togglePopup({
        pointer: 3,
        data: { 
          apt: enhancedAppointment, 
          editing: true,
          lockPatientName: true,
          showMouth: true
        }
      })
    )
  }

  // Open quick edit mode
  const openQuickEdit = (appointment) => {
    console.log('Appointment category:', appointment.category);
    
    // Ensure payment values are properly initialized as numbers
    const serviceCost = parseFloat(appointment.service_cost) || 0;
    const patientPay = parseFloat(appointment.patient_pay) || 0;
    const difference = serviceCost - patientPay;
    
    console.log('🔍 QUICK EDIT INITIALIZATION:', {
      appointmentId: appointment.id,
      originalServiceCost: appointment.service_cost,
      originalPatientPay: appointment.patient_pay,
      parsedServiceCost: serviceCost,
      parsedPatientPay: patientPay,
      calculatedDifference: difference
    });
    
    setQuickEditApt(appointment)
    setQuickEditForm({
      feedback: appointment.feedback || '',
      examination: appointment.examination || '',
      therapy: appointment.therapy || '',
      main_issue: appointment.main_issue || '',
      selectedTeeth: Array.isArray(appointment.teeth_list) ? appointment.teeth_list : [],
      selectedType: 'all',
      doctor_id: appointment.doctor_id || '',
      service_name: (appointment.name && appointment.name !== 'untitled') ? appointment.name : 
                   (appointment.operation_name && appointment.operation_name !== 'untitled') ? appointment.operation_name : '',
      category: appointment.category || 'general',
      service_cost: serviceCost,
      patient_pay: patientPay,
      difference: difference,
      date: appointment.date || new Date().toISOString().split('T')[0],
      time: appointment.fromStr || '09:00'
    })
  }

  // Handle quick edit form changes
  const handleQuickEditChange = (e) => {
    const { name, value } = e.target
    let newForm = {
      ...quickEditForm,
      [name]: value
    }

    // Calculate difference when service cost or patient payment changes
    if (name === 'service_cost' || name === 'patient_pay') {
      const serviceCost = name === 'service_cost' ? parseFloat(value) || 0 : parseFloat(quickEditForm.service_cost) || 0
      const patientPay = name === 'patient_pay' ? parseFloat(value) || 0 : parseFloat(quickEditForm.patient_pay) || 0
      newForm.difference = serviceCost - patientPay
      
      // Debug logging for payment changes
      console.log('🔍 FORM PAYMENT CHANGE:', {
        field: name,
        newValue: value,
        parsedServiceCost: serviceCost,
        parsedPatientPay: patientPay,
        calculatedDifference: newForm.difference
      });
    }

    setQuickEditForm(newForm)
  }

  // Handle teeth selection
  const handleToothClick = (toothNumber) => {
    let newTeethArray = [...quickEditForm.selectedTeeth];
    if (newTeethArray.includes(toothNumber)) {
      newTeethArray = newTeethArray.filter((tooth) => tooth !== toothNumber);
    } else {
      newTeethArray.push(toothNumber);
    }
    setQuickEditForm({
      ...quickEditForm,
      selectedTeeth: newTeethArray
    });
  }

  // Save quick edit changes
  const saveQuickEdit = () => {
    if (!quickEditApt) return

    // Find the selected doctor to get the name
    const selectedDoctor = users.find(user => user.id === quickEditForm.doctor_id);

    // Find the selected operation
    const selectedOperation = operations?.find(op => op.op_name === quickEditForm.service_name);

    // Calculate time values correctly
    const [hours, minutes] = quickEditForm.time.split(':').map(Number);
    const timeValue = hours + (minutes / 60);
    const nextTimeSlot = arrayOfTimesGeneral.find(time => time.value === timeValue + 0.5)?.displayValue || '09:30';

    // Menaxho pagesat në array_of_payments
    let updatedPayments = quickEditApt.array_of_payments ? [...quickEditApt.array_of_payments] : [];
    
    // Improved payment comparison logic to prevent false positives
    const currentPaymentAmount = parseFloat(quickEditForm.patient_pay) || 0;
    const originalPaymentAmount = parseFloat(quickEditApt.patient_pay) || 0;
    
    // Use more robust comparison with tolerance for floating point precision
    const hasPaymentChanges = Math.abs(currentPaymentAmount - originalPaymentAmount) > 0.01;
    const hasDateChanges = quickEditForm.date !== quickEditApt.date;
    
    // Debug logging to track payment changes
    console.log('🔍 PAYMENT COMPARISON DEBUG:', {
      currentPaymentAmount,
      originalPaymentAmount,
      hasPaymentChanges,
      hasDateChanges,
      currentDate: quickEditForm.date,
      originalDate: quickEditApt.date,
      existingPaymentsCount: updatedPayments.length
    });
    
    // Nëse pagesa bëhet 0, hiq të gjitha pagesat me keste
    if (currentPaymentAmount === 0) {
      updatedPayments = [];
    }
    // Vetëm nëse ka ndryshime reale dhe pagesa është më e madhe se 0, shto pagesë të re
    else if (hasPaymentChanges && currentPaymentAmount > 0 && quickEditForm.date) {
      // Kontrollo nëse ka tashmë një pagesë për këtë datë
      const existingPaymentIndex = updatedPayments.findIndex(payment => payment.date === quickEditForm.date);
      
      if (existingPaymentIndex >= 0) {
        // Përditëso pagesën ekzistuese për këtë datë
        updatedPayments[existingPaymentIndex] = {
          ...updatedPayments[existingPaymentIndex],
          amount: currentPaymentAmount,
          value: currentPaymentAmount
        };
        console.log('✅ Updated existing payment for date:', quickEditForm.date, 'Amount:', currentPaymentAmount);
      } else {
        // Shto pagesë të re vetëm nëse nuk ekziston për këtë datë
        updatedPayments.push({
          amount: currentPaymentAmount,
          value: currentPaymentAmount,
          date: quickEditForm.date
        });
        console.log('➕ Added new payment for date:', quickEditForm.date, 'Amount:', currentPaymentAmount);
      }
    } else {
      console.log('ℹ️ No payment changes detected - preserving existing payments');
    }
    
    // Llogarit totalin nga pagesat
    const totalFromPayments = updatedPayments.reduce((sum, payment) => 
      sum + (Number(payment.amount) || Number(payment.value) || 0), 0);

    const updatedAppointment = {
      ...quickEditApt,
      id: quickEditApt.id, // Explicitly ensure ID is preserved
      feedback: quickEditForm.feedback,
      examination: quickEditForm.examination,
      therapy: quickEditForm.therapy,
      main_issue: quickEditForm.main_issue,
      name: quickEditForm.service_name,
      doctor_id: quickEditForm.doctor_id || quickEditApt.doctor_id,
      doctor_name: selectedDoctor ? selectedDoctor.displayName : quickEditApt.doctor_name,
      // Add financial fields
      service_cost: parseFloat(quickEditForm.service_cost) || 0,
      patient_pay: totalFromPayments, // Përdor totalin nga array
      difference: (parseFloat(quickEditForm.service_cost) || 0) - totalFromPayments,
      // Update operation details
      operation_id: selectedOperation?.id || quickEditApt.operation_id,
      operation_name: quickEditForm.service_name,
      // Preserve patient details
      patient_id: quickEditApt.patient_id,
      patient_name: quickEditApt.patient_name,
      // Update date and time fields
      date: quickEditForm.date,
      from: timeValue,
      to: timeValue + 0.5,
      fromStr: quickEditForm.time,
      toStr: nextTimeSlot,
      // Preserve other important fields
      category: quickEditApt.category,
      unit_multiplier: quickEditApt.unit_multiplier,
      array_of_payments: updatedPayments,
      price: selectedOperation?.price || quickEditApt.price,
      is_paid: totalFromPayments >= (parseFloat(quickEditForm.service_cost) || 0),
      is_ongoing: quickEditApt.is_ongoing,
      color: quickEditApt.color,
      // Always update teeth_list with the selected teeth
      teeth_list: quickEditForm.selectedTeeth,
      payment_date: updatedPayments.length > 0 ? updatedPayments[updatedPayments.length - 1].date : null
    }

    updateAppointmentDirectly(updatedAppointment)
    setQuickEditApt(null)
  }

  // Cancel quick edit
  const cancelQuickEdit = () => {
    setQuickEditApt(null)
  }

  // Handle appointment deletion
  const handleDeleteApt = (appointment, keepInPatientHistory = false) => {
    if (!appointment) return;
    
    // Use the deleteAppointment action with the specified keepInPatientRecord value
    dispatch(deleteAppointment({ 
      id: appointment.id, 
      keepInPatientRecord: keepInPatientHistory 
    }));
    
    setQuickEditApt(null);
  };

  const autoResizeTextarea = (e) => {
    e.target.style.height = 'auto';
    e.target.style.height = (e.target.scrollHeight) + 'px';
  };

  return (
    <div className={styles.ptapt_container}>
      <div className={styles.header_container}>
        <h3 className={styles.header} style={{marginBottom:'30px'}}>
          <button className={styles.add_btn} onClick={createAppointment}>
            +
          </button>
          {t('appointments_list')}
        </h3>
      </div>

      {/* Quick Edit Modal */}
      <QuickEditModal
        quickEditApt={quickEditApt}
        quickEditForm={quickEditForm}
        users={users}
        handleQuickEditChange={handleQuickEditChange}
        handleToothClick={handleToothClick}
        setQuickEditForm={setQuickEditForm}
        autoResizeTextarea={autoResizeTextarea}
        onSaveQuickEdit={saveQuickEdit}
        cancelQuickEdit={cancelQuickEdit}
        handleDeleteApt={handleDeleteApt}
        isFromCalendar={false}
        t={t}
        setQuickEditApt={setQuickEditApt}
      />

      <ul className={styles.appointments_list}>
        {usedAppointments?.length ? (
          Object.entries(groupAppointmentsByDate(usedAppointments))
            .sort((a, b) => new Date(a[0]) - new Date(b[0]))
            .map(([date, appointmentsForDate]) => {
              const { full: fullDate } = dateFunction(date)
              
              return (
                <li key={date} className={`${styles.appointment_container_card} ${appointmentsForDate.length > 1 ? styles.grouped_appointment_card : ''}`}>
                  <div className={styles.date_pill}>
                    <span className={styles.date_month}>{fullDate}</span>
                  </div>
                  <div className={styles.divider} />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    {appointmentsForDate.length === 1 ? (
                      // Single appointment display
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span style={{ color: '#333', fontWeight: 600 }}>
                          {appointmentsForDate[0].name || appointmentsForDate[0].operation_name || t('no_operation')}
                        </span>
                        <span style={{ marginLeft: 8, color: '#2196f3', fontSize: '1.1em' }} title="Time">⏰</span>
                        <span style={{ fontWeight: 700, color: '#2196f3', marginLeft: 2 }}>
                          {appointmentsForDate[0].fromStr || t('no_time')}
                        </span>
                      </div>
                    ) : (
                      // Multiple appointments display
                      <div 
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleGroupedAppointmentClick(date, appointmentsForDate)}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                          <span style={{ color: '#333', fontWeight: 600 }}>
                            {appointmentsForDate.length} {t('appointments')}
                          </span>
                          <span className={styles.appointments_count_badge}>
                            {appointmentsForDate.length}
                          </span>
                        </div>
                        <div className={styles.appointments_preview}>
                          {appointmentsForDate.slice(0, 2).map((apt, index) => (
                            <span key={apt.id} className={styles.appointment_preview_item}>
                              {apt.name || apt.operation_name || t('no_operation')}
                              {index < 1 && appointmentsForDate.length > 2 ? ', ' : ''}
                            </span>
                          ))}
                          {appointmentsForDate.length > 2 && (
                            <span className={styles.more_appointments}>
                              +{appointmentsForDate.length - 2} {t('more')}
                            </span>
                          )}
                        </div>
                        {/* Show all teeth button for grouped appointments */}
                        <div style={{ marginTop: 8 }}>
                          <button
                            className={styles.show_teeth_button}
                            onClick={(e) => {
                              e.stopPropagation()
                              showAllTeethFromGroup(appointmentsForDate)
                            }}
                            title={t('show_all_teeth_from_group') || 'Show all teeth from this group'}
                          >
                            <span style={{ color: '#4caf50', fontSize: '1em' }}>🦷</span>
                            <span style={{ marginLeft: 4, fontSize: '0.9em' }}>
                              {t('show_all_teeth') || 'Show All Teeth'}
                            </span>
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className={styles.quick_actions}>
                    {appointmentsForDate.length === 1 ? (
                      <button 
                        className={styles.quick_action} 
                        title={t('quick_edit_notes')} 
                        onClick={() => openQuickEdit(appointmentsForDate[0])}
                      >
                        <span style={{ color: '#2196f3', fontSize: '1.2em' }} title="Quick Edit">📝</span>
                      </button>
                    ) : (
                      <button 
                        className={styles.quick_action} 
                        title={t('view_appointments')} 
                        onClick={() => handleGroupedAppointmentClick(date, appointmentsForDate)}
                      >
                        <span style={{ color: '#4caf50', fontSize: '1.2em' }} title="View All">👁️</span>
                      </button>
                    )}
                  </div>
                </li>
              )
            })
        ) : (
          <div className={styles.no_apts}>
            <p className={styles.txt}>{t('no_apts')}</p>
          </div>
        )}
      </ul>

      {/* Appointments Modal */}
      {showAppointmentsModal && (
        <div className={styles.appointments_modal_overlay}>
          <div className={styles.appointments_modal}>
            <div className={styles.modal_header}>
              <h3>
                {t('appointments_for')} {selectedDateAppointments[0]?.date ? new Date(selectedDateAppointments[0].date).toLocaleDateString('en-GB') : ''}
              </h3>
              <div className={styles.modal_header_actions}>
                <button
                  className={styles.show_teeth_button}
                  onClick={() => showAllTeethFromGroup(selectedDateAppointments)}
                  title={t('show_all_teeth_from_group') || 'Show all teeth from this group'}
                >
                  <span style={{ color: '#4caf50', fontSize: '1em' }}>🦷</span>
                  <span style={{ marginLeft: 4, fontSize: '0.9em' }}>
                    {t('show_all_teeth') || 'Show All Teeth'}
                  </span>
                </button>
                <button 
                  className={styles.close_modal_btn}
                  onClick={() => setShowAppointmentsModal(false)}
                >
                  ✖
                </button>
              </div>
            </div>
            <div className={styles.modal_content}>
              <div className={styles.appointments_list_modal}>
                {selectedDateAppointments.map((appointment) => (
                  <div
                    key={appointment.id}
                    className={styles.modal_appointment_item}
                    onClick={() => handleAppointmentSelect(appointment)}
                  >
                    <div className={styles.modal_appointment_header}>
                      <div className={styles.modal_appointment_info}>
                        <span className={styles.modal_appointment_name}>
                          {appointment.name || appointment.operation_name || t('no_operation')}
                        </span>
                        <div className={styles.modal_appointment_time}>
                          <span style={{ color: '#2196f3', fontSize: '1em' }} title="Time">⏰</span>
                          <span style={{ fontWeight: 600, color: '#2196f3', marginLeft: 4 }}>
                            {appointment.fromStr || t('no_time')}
                          </span>
                        </div>
                      </div>
                      <div className={styles.modal_appointment_actions}>
                        <button 
                          className={styles.quick_action}
                          onClick={(e) => {
                            e.stopPropagation()
                            setShowAppointmentsModal(false)
                            openQuickEdit(appointment)
                          }}
                          title={t('quick_edit_notes')}
                        >
                          <span style={{ color: '#2196f3', fontSize: '1.2em' }}>📝</span>
                        </button>
                      </div>
                    </div>
                    {(appointment.feedback || appointment.examination || appointment.therapy) && (
                      <div className={styles.modal_appointment_details}>
                        {appointment.feedback && (
                          <div className={styles.modal_detail_item}>
                            <span className={styles.detail_label}>{t('feedback')}:</span>
                            <span className={styles.detail_value}>{appointment.feedback}</span>
                          </div>
                        )}
                        {appointment.examination && (
                          <div className={styles.modal_detail_item}>
                            <span className={styles.detail_label}>{t('examination')}:</span>
                            <span className={styles.detail_value}>{appointment.examination}</span>
                          </div>
                        )}
                        {appointment.therapy && (
                          <div className={styles.modal_detail_item}>
                            <span className={styles.detail_label}>{t('therapy')}:</span>
                            <span className={styles.detail_value}>{appointment.therapy}</span>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default PatientAppointments
